
/* ElenSerica Premium Catalog Menu
   Uses the existing Dawn menu and existing Menu Image blocks. It does not replace menu markup. */
(function () {
  const DESKTOP = '(min-width: 990px) and (pointer: fine)';

  function getImageForLink(link) {
    if (!link) return null;
    const own = link.closest('li')?.querySelector(':scope > ul .mega_menu_img img');
    if (own) return own;
    return link.closest('li')?.querySelector('.mega_menu_img img') || null;
  }

  function getTitleForImage(img, fallback) {
    const card = img?.closest('.mega_menu_img');
    const title = card?.querySelector('.title')?.textContent?.trim();
    return title || fallback || '';
  }

  function init(root) {
    if (!root || root.dataset.esPremiumReady === 'true') return;
    root.dataset.esPremiumReady = 'true';

    root.querySelectorAll(':scope > .list-menu--inline > li > header-menu > .mega-menu').forEach((menu) => {
      const content = menu.querySelector(':scope > .mega-menu__content');
      if (!content) return;

      const links = Array.from(content.querySelectorAll('.mega-menu__link--level-2, .mega-menu__link:not(.mega-menu__link--level-2)'));
      const firstImage = content.querySelector('.mega_menu_img img');

      const preview = document.createElement('div');
      preview.className = 'es-premium-mega-preview';
      preview.innerHTML = `
        <a class="es-premium-mega-preview__link" href="#">
          <img class="es-premium-mega-preview__image" alt="" loading="lazy">
          <span class="es-premium-mega-preview__shade" aria-hidden="true"></span>
          <span class="es-premium-mega-preview__copy">
            <span class="es-premium-mega-preview__eyebrow"></span>
            <span class="es-premium-mega-preview__title"></span>
            <span class="es-premium-mega-preview__cta">Explore <span aria-hidden="true">→</span></span>
          </span>
        </a>`;
      content.appendChild(preview);

      const previewLink = preview.querySelector('.es-premium-mega-preview__link');
      const image = preview.querySelector('.es-premium-mega-preview__image');
      const eyebrow = preview.querySelector('.es-premium-mega-preview__eyebrow');
      const title = preview.querySelector('.es-premium-mega-preview__title');

      let current = '';
      let timer;

      function showFor(link) {
        const source = getImageForLink(link);
        if (!source?.currentSrc && !source?.src) return;
        const src = source.currentSrc || source.src;
        if (!src || src === current) {
          preview.classList.add('is-visible');
          return;
        }
        current = src;
        const sourceCard = source.closest('.mega_menu_img');
        const sourceAnchor = sourceCard?.querySelector('a[href]');
        const label = getTitleForImage(source, link.textContent.trim());
        eyebrow.textContent = link.textContent.trim();
        title.textContent = label;
        if (sourceAnchor) {
          previewLink.href = sourceAnchor.href;
          if (sourceAnchor.target) previewLink.target = sourceAnchor.target;
          else previewLink.removeAttribute('target');
          if (sourceAnchor.rel) previewLink.rel = sourceAnchor.rel;
          else previewLink.removeAttribute('rel');
        }
        const preload = new Image();
        preload.onload = function () {
          image.src = src;
          image.alt = label;
          preview.classList.add('is-visible');
        };
        preload.src = src;
      }

      function open() {
        if (!window.matchMedia(DESKTOP).matches) return;
        clearTimeout(timer);
        menu.setAttribute('open', '');
      }

      function close() {
        clearTimeout(timer);
        timer = setTimeout(() => menu.removeAttribute('open'), 180);
      }

      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', close);

      links.forEach((link) => {
        link.addEventListener('mouseenter', () => showFor(link));
        link.addEventListener('focus', () => showFor(link));
      });

      if (firstImage) {
        const firstLink = links.find((link) => getImageForLink(link));
        if (firstLink) showFor(firstLink);
      } else {
        menu.classList.add('es-premium-mega-menu--no-preview');
        preview.remove();
      }

      const summary = menu.querySelector(':scope > summary');
      if (summary) {
        summary.addEventListener('click', (event) => {
          if (!window.matchMedia(DESKTOP).matches) return;
          event.preventDefault();
          const isOpen = menu.hasAttribute('open');
          root.querySelectorAll('.mega-menu[open]').forEach((other) => {
            if (other !== menu) other.removeAttribute('open');
          });
          if (isOpen) menu.removeAttribute('open');
          else menu.setAttribute('open', '');
        });
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      root.querySelectorAll('.mega-menu[open]').forEach((menu) => menu.removeAttribute('open'));
    });
  }

  function boot() {
    document.querySelectorAll('.header__inline-menu').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
